import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	CFICheckInformationPanel,
	ChangeOrderButton,
	COCFiles,
	CreateEstimateButton,
	ExitButton,
	PlumbingBanner,
	PrintButton,
	RequestCancellationButton,
	RetailOrderAddNoteButton,
	RetailOrderCommunicationButton,
	RetailOrderDatesPanel,
	RetailOrderFilesButton,
	RetailOrderInformationCards,
	RetailOrderNotesPanel,
	RetailOrderPage,
	RetailOrderProducts,
	RetailOrderProgress,
	RetailOrderProgressStep,
	RetailOrderReportType,
	SubmitFilesButton,
	ViewChangeRequestButton
} from '../../../features/cfi/retail-order';
import '../../../css/order.scss';

export default function UploadCOCPage() {

	return (
		<RetailOrderPage>

			<PlumbingBanner />

			<RetailOrderInformationCards showPaymentInformationCard={true} />

			<RetailOrderProgress />

			<Box>
				<Item ratio={1}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<SubmitFilesButton />
						</ToolbarItem>
						<ToolbarItem>
							<PrintButton reportType={RetailOrderReportType.Invoice} />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderCommunicationButton />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderFilesButton />
						</ToolbarItem>
						<ToolbarItem>
							<CreateEstimateButton />
						</ToolbarItem>
						<ToolbarItem>
							<ChangeOrderButton step={RetailOrderProgressStep.UploadFiles} />
						</ToolbarItem>
						<ToolbarItem>
							<ViewChangeRequestButton step={RetailOrderProgressStep.UploadFiles} />
						</ToolbarItem>
						<ToolbarItem>
							<RequestCancellationButton />
						</ToolbarItem>
						<ToolbarItem>
							<ExitButton />
						</ToolbarItem>
					</Toolbar>
				</Item>
				<Item ratio={0} baseSize={190}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<RetailOrderAddNoteButton showNoteType={false} changeOrder={false} />
						</ToolbarItem>
					</Toolbar>
				</Item>
			</Box>


			<Box>
				<Item ratio={1}>
					<Box direction='col' className='upload-coc-panels'>
						<Item baseSize={200}>
							<CFICheckInformationPanel />
						</Item>
						<Item baseSize={250}>
							<RetailOrderDatesPanel
								showScheduledInstallDates={true}
								showActualInstallDates={true}
								showInvoiceDate={false}
								editCabinetDates={false} />
						</Item>
					</Box>
				</Item>
				<Item ratio={1}>
					<RetailOrderNotesPanel height={400} />
				</Item>
			</Box>

			<COCFiles />

			<RetailOrderProducts />

		</RetailOrderPage>
	)
}
